// @vendor
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

// @actions
import accountValidationsActions from 'actions/accountValidation'

// @components
import { LoadingScreen } from 'components/loadingScreen/loadingScreen';
import AccountValidationModal from './accountValidationModal/accountValidationModal'
import { InformationContent } from './accountValidationModal/components/informationContent';

// @constants
import { OPTION_ACCOUNT_CANCELLATION_ACCOUNT, OPTION_ACCOUNT_TRANSFER_ACCOUNT_FROM_OTHER_BANK } from 'constants/accounts';
import { useModalValidation } from './hooks/useModalValidation';
import { getAccountProducts } from './helpers/accountExtendHelper';
import { taggingReTryEvent } from './helpers/tagging';

const getAccountValidationSuccessMessage = (optionSelected) => {
    if (optionSelected === OPTION_ACCOUNT_CANCELLATION_ACCOUNT) {
        return <InformationContent />
    }
}

function extendAccountFunctionality(WrappedComponent) {
     const WithExtendedFunctionality = ({
        immAccountValidation,
        history,
        match,
        validateAccountCancellation,
        validateTransferAccount,
        resetAccountValidate,
        immAccounts,
        immScreen,
        ...props
     }) => {
        const [optionSelected, setOptionSelected] = useState(null);
        const { openModal,
            isServiceFailed,
            getValidationMessage,
            handlePrimaryButtonAction,
            handleCancel,
        } = useModalValidation({immAccountValidation, history, accountId: match?.params?.accountId, optionSelected, resetAction: resetAccountValidate });

        const isFetching = immAccountValidation.get('isFetching');

        useEffect(() => {
            return () => {
                resetAccountValidate()
            }
        }, [])

        const handleRequest = (option, isRetry) => {
            const { params: { accountId } } = match
            setOptionSelected(option)

            isRetry && taggingReTryEvent(immAccountValidation)

            switch (option) {
                case OPTION_ACCOUNT_CANCELLATION_ACCOUNT:
                    const { oldContract, newContract } = getAccountProducts(immAccounts, accountId);
                    validateAccountCancellation(oldContract, newContract);
                    break;
                case OPTION_ACCOUNT_TRANSFER_ACCOUNT_FROM_OTHER_BANK:
                    const accountMbId = immAccounts.getIn(['byId', accountId]).get('accountMbId');
                    validateTransferAccount(accountMbId, () => {
                        history.push(`/myprofile/accounts/${accountId}/transfer`);
                    });
                    break;
            }
        }

        const handleOptionsClick = (option) => {
            setOptionSelected(option);
            handleRequest(option);
        }

        return (
            <>
                {
                    isFetching && <LoadingScreen isMobile={immScreen.get('isMobile')} />
                }
                <WrappedComponent 
                    {...props}
                    history={history}
                    match={match}
                    immAccounts={immAccounts}
                    handleOptionsClick={handleOptionsClick}
                />
                <AccountValidationModal
                    openModal={openModal && !isFetching}
                    immAccountValidation={immAccountValidation}
                    resetAction={resetAccountValidate}
                    isServiceFailed={isServiceFailed}
                    validationMessage={getValidationMessage()}
                    optionSelected={optionSelected}
                    onRetry={() => handleRequest(optionSelected, true)}
                    onClick={handlePrimaryButtonAction}
                    onCancel={handleCancel}
                >
                    {getAccountValidationSuccessMessage(optionSelected)}
                </AccountValidationModal>
            </>
        );
    }

    return connect(state => ({
        immAccountValidation: state.accountValidation,
        immScreen: state.screen,
    }), {
        validateAccountCancellation: accountValidationsActions.validateAccountCancellation,
        resetAccountValidate: accountValidationsActions.resetAccountValidate,
        validateTransferAccount: accountValidationsActions.validateTransferAccount,
    })(WithExtendedFunctionality);
}

export default extendAccountFunctionality;
